/* !
 * jQuery case v1.0.0
 * Copyright 2016, Connecty Inc.
 * use: Vue.js v1.0.28
 */
(function($, SANGETSU){
	const v = 'is-visible';
	const n = 'is-novisible';
	const l = 'is-loading';
	let timer = false;
	let thisId;
	if (SANGETSU.va.pathname.indexOf('detail') !== -1) {
		thisId = SANGETSU.va.pathname.split('/')[3].replace(/\.html/g, ''); // URLからID取得
	}
	let searchCat = [], searchEle = [], searchKeyword = [];
	if (location.search && (location.search.indexOf('category=') !== -1 || location.search.indexOf('element=') !== -1 || location.search.indexOf('keyword=') !== -1)) {
		let searchArr = location.search.split('&');
		for (let i = 0; i < searchArr.length; i++) {
			if (searchArr[i].indexOf('category') !== -1) {
				searchCat.push(searchArr[i].split('=')[1]);
			}
			if (searchArr[i].indexOf('element') !== -1) {
				searchEle.push(searchArr[i].split('=')[1]);
			}
			if (searchArr[i].indexOf('keyword') !== -1) {
				searchKeyword.push(searchArr[i].split('=')[1]);
			}
		}
	}

	// CSV取得
	const csvToArray = (strData) => {
		const strDelimiter = ',';
		const objPattern = new RegExp(
			(
				'(\\' + strDelimiter + '|\\r?\\n|\\r|^)' +
				'(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|' +
				'([^\"\\' + strDelimiter + '\\r\\n]*))'
			),
			'gi'
		);
		let arrData = [[]];
		let arrMatches = null;
		let strMatchedValue;
		while((arrMatches = objPattern.exec(strData)) !== null) {
			let strMatchedDelimiter = arrMatches[1];
			if(strMatchedDelimiter.length && (strMatchedDelimiter !== strDelimiter)) {
				arrData.push([]);
			}
			if(arrMatches[2]) {
				strMatchedValue = arrMatches[2].replace(new RegExp('\"\"', 'g'), '\"');
			} else {
				strMatchedValue = arrMatches[3];
			}
			arrData[arrData.length - 1].push(strMatchedValue);
		}
		// console.dir(arrData);

		let items = arrData[0];
		let jsonArr = [];
		for(let i = 1; i < arrData.length - 1; i++) {
			if(arrData[i].length) {
				let a_line = {};
				let csvArrayD = arrData[i];
				for(let j = 0; j < items.length; j++) {
					a_line[items[j]] = csvArrayD[j];
				}
				jsonArr.push(a_line);
			}
		}
		return(jsonArr);
	};

	// ＜一覧＞画像事前読み込み
	const promiseThumbnailImageLoad = () => {
		const d = $.Deferred();
		const $img = $('.case-list').find('img');
		const imgLen = $img.length;
		let array = [];

		const sum = (_$this) => {
			array.push(_$this);
			if(imgLen === array.length) {
				d.resolve();
			}
		};
		const loaded = (_$this) => {
			if(_$this.complete) {
				sum(_$this);
			} else {
				let img = new Image();
				img.src = _$this[0].src;
				img.addEventListener('load', () => sum(_$this));
			}
		};

		if(imgLen === 0) {
			d.resolve();
		} else {
			for(let i=0; i < imgLen; i++) {
				loaded($img.eq(i));
			}
		}

		return d.promise();
	};

	// ＜詳細＞画像事前読み込み
	const promiseDetailImageLoad = () => {
		const d = $.Deferred();
		const $img = $('.case-detail-img').find('img');
		const imgLen = $img.length;
		let array = [];

		const sum = (_$this) => {
			array.push(_$this);
			if(imgLen === array.length) {
				d.resolve();
			}
		};
		const loaded = (_$this) => {
			let img = new Image();
			img.src = _$this[0].src;
			img.addEventListener('load', () => sum(_$this));
		};

		for(var i=0; i < imgLen; i++) {
			loaded($img.eq(i));
		}

		return d.promise();
	};

	// 一覧読み込み完了時の処理
	const endLoad = () => {
		if(SANGETSU.va.pathname.indexOf('detail') === -1) {
			// 一覧ページ
			$.when(
				promiseThumbnailImageLoad()
			).done(function(){
				$('.case-list-name').matchHeight();
				$('.mod-loader').removeClass(l);
				$('.case-main').addClass(v);
				$('img').bind('contextmenu', function(){
					return false;
				});
			});
		} else {
			// 詳細ページ
			$.when(
				promiseDetailImageLoad()
			).done(function(){
				$('.case-detail-img').owlCarousel({
					items: 1,
					autoplay: false,
					loop: true,
					nav: true,
					navText: '',
					dots: false,
					thumbs: true,
					thumbImage: true,
					thumbContainerClass: 'owl-thumbs',
					thumbItemClass: 'owl-thumb-item'
				});
				$('.mod-loader').removeClass(l);
				$('.case_detail').addClass(v);
				$('img').bind('contextmenu', function(){
					return false;
				});
			});
		}
	};

	// -- ▲ functions ▲ -------------------------------------------------------------------
	// ------------------------------------------------------------------------------------

	let csvData = new XMLHttpRequest();
	csvData.open('get', '/case/item.csv', true);
	csvData.send(null);
	csvData.onload = function(){
		let json = csvToArray(csvData.responseText);

		let vue = new Vue({
			el: '#vue-item',
			data: {
				jsonData: json,
				checkedCategory: searchCat ? searchCat : [],
				checkedElement: searchEle ? searchEle : [],
				checkedTaste: [],
				checkedKeyword: searchKeyword ? searchKeyword : [],
				num: 0,
				page: 0,
				dispItemSize: 12
			},
			created: function(){
				this.$watch('checkedCategory', function(){
					this.page = 0;
					this.$nextTick(function(){
						$('.case-list-name').matchHeight();
					});
				});
				this.$watch('checkedElement', function(){
					this.page = 0;
					this.$nextTick(function(){
						$('.case-list-name').matchHeight();
					});
				});
				this.$watch('checkedTaste', function(){
					this.page = 0;
					this.$nextTick(function(){
						$('.case-list-name').matchHeight();
					});
				});
				this.$watch('checkedKeyword', function(){
					this.page = 0;
					this.$nextTick(function(){
						$('.case-list-name').matchHeight();
					});
				});
				this.$watch('page', function(){
					this.$nextTick(function(){
						$('.case-list-name').matchHeight();
					});
				});
			},
			methods: {
				showPrev: function(){
					if(this.isStartPage) return;
					this.page--;
					$(window).scrollTop(0);
				},
				showNext: function(){
					if(this.isEndPage) return;
					this.page++;
					$(window).scrollTop(0);
				},
				showPage: function(index){
					this.page = index;
					$(window).scrollTop(0);
				},
				setURL: function(_id){
					return'/case/detail/'+ ('000'+_id).slice(-4) + '.html';
				},
				setThumb: function(_id){
					return'/images/case/'+ ('000'+_id).slice(-4) + '_01_s.jpg';
				},
				setImg: function(_id, images){
					const imgList = images.split('\n');
					let imgListHTML = '';
					for(let i = 0; i < imgList.length; i++) {
						imgListHTML += '<div class="case-detail-img-item">'+
							`<img src='/images/case/${('000'+_id).slice(-4)}_${('00'+(i+1)).slice(-2)}.jpg'>`+
							`<span>${imgList[i]}</span></div>`;
					}
					return(imgListHTML);
				},
				setCategory: function(_cats) {
					const catList = _cats.split('\n');
					let catListHTML = '';
					catList.forEach(ele => {
						switch (ele) {
							case 'clinic':    catListHTML += '<li><span>医療施設</span></li>'; break;
							case 'welfare':   catListHTML += '<li><span>福祉施設</span></li>'; break;
							case 'office':    catListHTML += '<li><span>会社施設</span></li>'; break;
							case 'logistics': catListHTML += '<li><span>物流施設</span></li>'; break;
							case 'shop':      catListHTML += '<li><span>商業施設</span></li>'; break;
							case 'public':    catListHTML += '<li><span>公共施設</span></li>'; break;
							case 'education': catListHTML += '<li><span>文教施設</span></li>'; break;
							case 'lodging':   catListHTML += '<li><span>宿泊・宴会施設</span></li>'; break;
							case 'house':     catListHTML += '<li><span class="_ls">住宅・マンション</span></li>'; break;
							case 'vehicles':  catListHTML += '<li><span>車両・船舶</span></li>'; break;
							case 'traffic':   catListHTML += '<li><span>交通施設</span></li>'; break;
							default: break;
						}
					});
					return catListHTML;
				},
				setCredit: function(credit){
					const creditList = credit.split('\n');
					let creditListHTML = '';
					for(let i = 0; i < creditList.length; i++) {
						creditListHTML += `<li><span>${creditList[i]}</span></li>`;
					}
					return(creditListHTML);
				},
				setNewIcon: function(_update){
					const thisDate = new Date();
					const updateDate = new Date(
						Number(_update.split('/')[0]),
						Number(_update.split('/')[1])-1,
						Number(_update.split('/')[2]), 0, 0, 0);

					// 30日以内ならNEWマーク
					if((thisDate - updateDate) / 86400000 < 30) {
						return'<span>NEW</span>';
					} else {
						return'';
					}
				}
			},
			computed: {
				filterItems: function(){
					let items = this.jsonData;

					// category
					if (this.checkedCategory.length) {
						let itemsCat = [];
						for (let i = 0; i < items.length; i++) {
							let thisCatArr = items[i].cat.split('\n');
							for (let j = 0; j < thisCatArr.length; j++) {
								if (this.checkedCategory.indexOf(thisCatArr[j]) !== -1) {
									itemsCat.push(items[i]); break;
								}
							}
						}
						items = itemsCat;
					}
					// element
					if (this.checkedElement.length) {
						let itemsElement = [];
						for (let i = 0; i < items.length; i++) {
							let thisElementArr = items[i].element.split('\n');
							for (let j = 0; j < thisElementArr.length; j++) {
								if (this.checkedElement.indexOf(thisElementArr[j]) !== -1) {
									itemsElement.push(items[i]); break;
								}
							}
						}
						items = itemsElement;
					}
					// taste
					if (this.checkedTaste.length) {
						let itemsTaste = [];
						for(let i = 0; i < items.length; i++) {
							let thisTasteArr = items[i].taste.split('\n');
							for(let j = 0; j < thisTasteArr.length; j++) {
								if(this.checkedTaste.indexOf(thisTasteArr[j]) !== -1) {
									itemsTaste.push(items[i]); break;
								}
							}
						}
						items = itemsTaste;
					}
					// keyword
					if (this.checkedKeyword.length) {
						let itemsKeyword = [];
						for(let i = 0; i < items.length; i++) {
							let thisKeywordArr = items[i].keyword.split('\n');
							for(let j = 0; j < thisKeywordArr.length; j++) {
								if(this.checkedKeyword.indexOf(thisKeywordArr[j]) !== -1) {
									itemsKeyword.push(items[i]); break;
								}
							}
						}
						items = itemsKeyword;
					}
					// count
					this.num = items.length;
					// paging
					let startPage = this.page * this.dispItemSize;
					items = items.slice(startPage, startPage + this.dispItemSize);

					return(items);
				},
				filterDetailItem: function(){
					let items = [];
					for(let i = 0; i < this.jsonData.length; i++) {
						if(thisId === ('000'+this.jsonData[i].id).slice(-4)) {
							items.push(this.jsonData[i]); break;
						}
					}
					if(items.length) {
						return(items);
					} else {
						// 存在しないIDでアクセスされた場合は404へリダイレクト
						location.href = '/404.html';
						return false;
					}
				},
				isStartPage: function(){
					return(this.page === 0);
				},
				isEndPage: function(){
					return((this.page + 1) * this.dispItemSize >= this.num);
				},
				pageCount: function(){
					return Math.ceil(this.num / this.dispItemSize);
				}
			}
		});

		// 初回読み込み
		vue.$nextTick(function(){
			$('.case-main').removeClass(n);
			endLoad();
		});

		// 一覧の場合、matchHeight
		if(SANGETSU.va.pathname.indexOf('detail') === -1) {
			$('.mod-searchForm-hide').on('click', () => {
				$('.mod-searchForm-hide-switch').toggleClass('is-active');
				$('.mod-searchForm-detail').stop().slideToggle('fast');
			});

			$(window).resize(function(){
				if(timer !== false) {
					clearTimeout(timer);
				}
				timer = setTimeout(function(){
					$('.case-list-name').matchHeight();
				}, '200');
			});
		}
	};

})(window.jQuery, window.SANGETSU);
